import { defineMessages, IntlShape } from 'dibs-react-intl';

type SortOptionAlphabetical = Record<'alphabetical', 'FIRM_NAME_ASC'>;
type SortOptionMostRecent = Record<'mostRecent', 'PROJECT_PUBLISH_DATE_DESC'>;
type SortOptionsRanked = Record<'ranked', 'RANKED'>;

type SortOptionsType = SortOptionAlphabetical & SortOptionMostRecent & SortOptionsRanked;

export const designerDirectorySortOptions: SortOptionsType = {
    alphabetical: 'FIRM_NAME_ASC',
    mostRecent: 'PROJECT_PUBLISH_DATE_DESC',
    ranked: 'RANKED',
};

export const getSortValue = (label: keyof SortOptionsType): string => {
    if (!label) {
        return designerDirectorySortOptions.ranked;
    }

    return designerDirectorySortOptions[label] || designerDirectorySortOptions.ranked;
};

export const getSortUrlLabel = (value: string): string => {
    switch (value) {
        case designerDirectorySortOptions.mostRecent:
            return 'mostRecent';
        case designerDirectorySortOptions.alphabetical:
            return 'alphabetical';
        case designerDirectorySortOptions.ranked:
        default:
            return 'ranked';
    }
};

const messages = defineMessages({
    alphabetical: {
        id: 'abt.DesignerDirectorySort.aToZ',
        defaultMessage: 'Alphabetically',
    },
    mostRecent: {
        id: 'abt.DesignerDirectorySort.mostRecent',
        defaultMessage: 'Most Recent Project',
    },
    sortLabel: {
        id: 'abt.DesignerDirectorySort.label',
        defaultMessage: 'Sort By',
    },
    ranked: {
        id: 'abt.DesignerDirectorySort.ranked',
        defaultMessage: 'Featured Firms',
    },
});

type SortOptionOutput = {
    label: string;
    value: string;
};
export const getSortOptions = (intl: IntlShape): SortOptionOutput[] => {
    return [
        {
            label: intl.formatMessage(messages.ranked),
            value: designerDirectorySortOptions.ranked,
        },
        {
            label: intl.formatMessage(messages.alphabetical),
            value: designerDirectorySortOptions.alphabetical,
        },
        {
            label: intl.formatMessage(messages.mostRecent),
            value: designerDirectorySortOptions.mostRecent,
        },
    ];
};

export const getSortLabel = (intl: IntlShape): string => intl.formatMessage(messages.sortLabel);
